import React from 'react';
import { observer } from 'mobx-react';
import { Card, CardBody, Container } from 'reactstrap';
import { PageNames } from 'shared/constants/appConstants';
import PageHeader from 'shared/components/PageHeader';
import FilterGroupTable from 'usage/containers/FilterGroup/components/FilterGroupTable';

const FilterGroup = (props) => (
  <Container className="categories">
    <PageHeader title={PageNames.FILTER_GROUP} />
    <Card>
      <CardBody>
        <FilterGroupTable {...props} />
      </CardBody>
    </Card>
  </Container>
);


export default observer(FilterGroup);
